(() => {
 function initialize() {
  document.querySelectorAll('[data-jp-category-menu]').forEach(menu => {
   if(menu.dataset.jpReady) return; menu.dataset.jpReady='true';
   menu.addEventListener('keydown', event => { if(event.key==='Escape') { menu.open=false; menu.querySelector('summary').focus(); }});
   menu.addEventListener('click', event => { if(event.target.closest('a')) menu.open=false; });
  });
 }
 document.addEventListener('click', event => { document.querySelectorAll('[data-jp-category-menu][open]').forEach(menu => { if(!menu.contains(event.target)) menu.open=false; }); });
 document.addEventListener('shopify:section:load',initialize);
 initialize();
})();
